module.exports = __webpack_public_path__ + "img/dockercompose.3af6d75e.png";